import cjsModule from './index.js';

export const ModuleMocker = cjsModule.ModuleMocker;
export const fn = cjsModule.fn;
export const mocked = cjsModule.mocked;
export const replaceProperty = cjsModule.replaceProperty;
export const spyOn = cjsModule.spyOn;
